import PageHero from "../components/sections/PageHero";

const sections = [
  {
    h: "Information We Collect",
    p: "Lex Polaris, Advocates & Solicitors may collect basic information voluntarily submitted by visitors through contact forms or direct communication, such as name, phone number, email address, matter type and any details shared in the message field.",
  },
  {
    h: "Use of Personal Information",
    p: "Information submitted is reviewed strictly for consultation purposes and to respond to enquiries. The firm does not use submitted information for marketing or unsolicited communication.",
  },
  {
    h: "Confidentiality",
    p: "Information shared with the firm is treated with appropriate confidentiality. However, submission of information through this website does not by itself create a lawyer-client relationship.",
  },
  {
    h: "Cookies and Analytics",
    p: "The website may use limited cookies and analytics tools to understand how visitors interact with the site. This information is used to improve the user experience and is not used to identify individuals.",
  },
  {
    h: "Third-Party Tools",
    p: "The website may use third-party tools for hosting, analytics or communication. Such tools may have their own privacy practices, governed by their respective terms.",
  },
  {
    h: "Data Protection",
    p: "Reasonable measures are taken to protect information against unauthorised access. However, no online medium can guarantee absolute security.",
  },
  {
    h: "Contact for Privacy Concerns",
    p: "For any questions regarding privacy or the use of information submitted through this website, please write to admin@lexpolaris.in.",
  },
];

export default function PrivacyPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        subtitle="How Lex Polaris handles information submitted through this website."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Privacy Policy" }]}
      />
      <section className="bg-ivory section-y" data-testid="privacy-content">
        <div className="container-px max-w-3xl mx-auto">
          {sections.map((s, i) => (
            <div key={s.h} className="mb-10 md:mb-12" data-testid={`privacy-section-${i}`}>
              <h2 className="font-serif text-2xl md:text-3xl text-navy mb-4">{s.h}</h2>
              <p className="body-lg text-charcoal/80">{s.p}</p>
            </div>
          ))}
          <p className="text-xs tracking-[0.22em] uppercase text-charcoal/55 mt-12 pt-8 border-t border-soft-grey">
            Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}
          </p>
        </div>
      </section>
    </>
  );
}
